export const configure = {
	StorageKey: {
		Vendor: "vendor",
		CurrentStore: "current-store",
		CurrentStoreBranch: "current-store-branch",
		Waiter: "waiter",
		IsStoreOpen: 'store-open'
	}
}